let routes = [
    // 苯酐
    {
        path: 'anhydride',
        name: '苯酐',
        component: () => import('@/views/anhydride/index'),
    },
    {
        path: 'anhydride/twoPage/industry',
        name: '苯酐行业动态二级页',
        component: () => import('@/views/anhydride/twoPage/industry')
    },
    {
        path: 'anhydride/industry',
        name: '苯酐行业动态详情页',
        component: () => import('@/views/anhydride/detail/industry')
    },
    {
        path: 'anhydride/twoPage/price',
        name: '苯酐价格二级页',
        component: () => import('@/views/anhydride/twoPage/price')
    },
    {
        path: 'anhydride/price',
        name: '苯酐价格详情页',
        component: () => import('@/views/anhydride/detail/price')
    },
    {
        path: 'anhydride/twoPage/device',
        name: '苯酐装置动态二级页',
        component: () => import('@/views/anhydride/twoPage/device')
    },
    {
        path: 'anhydride/device',
        name: '苯酐装置动态详情页',
        component: () => import('@/views/anhydride/detail/device')
    },
    {
        path: 'anhydride/twoPage/report',
        name: '苯酐研究报告二级页',
        component: () => import('@/views/anhydride/twoPage/report')
    },
    {
        path: 'anhydride/twoPage/standard',
        name: '苯酐技术及标准二级页',
        component: () => import('@/views/anhydride/twoPage/standard')
    },
    {
        path: 'anhydride/twoPage/exit',
        name: '苯酐进出口二级页',
        component: () => import('@/views/anhydride/twoPage/exit')
    },
    {
        path: 'anhydride/exit',
        name: '苯酐进出口详情页',
        component: () => import('@/views/anhydride/detail/exit')
    },
    {
        path: 'anhydride/twoPage/yield',
        name: '苯酐产量二级页',
        component: () => import('@/views/anhydride/twoPage/yield')
    },
    {
        path: 'anhydride/yield',
        name: '苯酐产量详情页',
        component: () => import('@/views/anhydride/detail/yield')
    },
    {
        path: 'anhydride/twoPage/profit',
        name: '苯酐利润二级页',
        component: () => import('@/views/anhydride/twoPage/profit')
    },
    {
        path: 'anhydride/profit',
        name: '苯酐利润详情页',
        component: () => import('@/views/anhydride/detail/profit')
    },
    {
        path: 'anhydride/twoPage/rate',
        name: '苯酐开工率二级页',
        component: () => import('@/views/anhydride/twoPage/rate')
    },
    {
        path: 'anhydride/rate',
        name: '苯酐开工率详情页',
        component: () => import('@/views/anhydride/detail/rate')
    },
    {
        path: 'anhydride/twoPage/addPrice',
        name: '苯酐增塑剂价格二级页',
        component: () => import('@/views/anhydride/twoPage/addPrice')
    },
    {
        path: 'anhydride/addPrice',
        name: '苯酐增塑剂价格详情页',
        component: () => import('@/views/anhydride/detail/addPrice')
    },
    {
        path: 'anhydride/twoPage/addRate',
        name: '苯酐增塑剂开工率二级页',
        component: () => import('@/views/anhydride/twoPage/addRate')
    },
    {
        path: 'anhydride/addRate',
        name: '苯酐增塑剂开工率详情页',
        component: () => import('@/views/anhydride/detail/addRate')
    },
    {
        path: 'anhydride/twoPage/addYield',
        name: '苯酐增塑剂产量二级页',
        component: () => import('@/views/anhydride/twoPage/addYield')
    },
    {
        path: 'anhydride/addYield',
        name: '苯酐增塑剂产量详情页',
        component: () => import('@/views/anhydride/detail/addYield')
    },
    {
        path: 'anhydride/twoPage/cutWater',
        name: '苯酐减水剂二级页',
        component: () => import('@/views/anhydride/twoPage/cutWater')
    },
    {
        path: 'anhydride/cutWater',
        name: '苯酐减水剂详情页',
        component: () => import('@/views/anhydride/detail/cutWater')
    },
    {
        path: 'anhydride/twoPage/addProfit',
        name: '苯酐增塑剂利润二级页',
        component: () => import('@/views/anhydride/twoPage/addProfit')
    },
    {
        path: 'anhydride/addProfit',
        name: '苯酐增塑剂利润详情页',
        component: () => import('@/views/anhydride/detail/addProfit')
    },
]

export default routes;
